import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "wx-open-app" };
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        appid: { default: 'wxeb44a864bdd935be' },
        extinfo: { default: '' },
        text: { default: '打开APP' },
        style: { default: '' }
    },
    setup: function (__props) {
        var props = __props;
        var styles = "width: 334px;\n            height: 52px;\n            background: #ff8024;\n            border-radius: 26px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            font-size: 18px;\n            font-family: PingFangSC-Regular, PingFang SC;\n            font-weight: 400;\n            color: #ffffff;";
        var launchBtnRef = ref();
        var handleReadyFn = function () {
            launchBtnRef.value.addEventListener('launch', function () {
                console.log('launch');
            });
            launchBtnRef.value.addEventListener('error', function (e) {
                console.log('error:', e.detail);
                // window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.zaojiao.app'
            });
        };
        setTimeout(function () {
            console.log(props, 'props');
        }, 3000);
        return function (_ctx, _cache) {
            var _component_wx_open_launch_app = _resolveComponent("wx-open-launch-app");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_wx_open_launch_app, {
                    id: "launch-btn",
                    ref_key: "launchBtnRef",
                    ref: launchBtnRef,
                    appid: props.appid,
                    extinfo: props.extinfo,
                    onReady: handleReadyFn
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/wxtag-template" }, {
                            default: _withCtx(function () { return [
                                _renderSlot(_ctx.$slots, "default", {}, function () { return [
                                    _createElementVNode("div", {
                                        class: "btn",
                                        style: _normalizeStyle(styles + props.style)
                                    }, _toDisplayString(props.text), 5)
                                ]; })
                            ]; }),
                            _: 3
                        }))
                    ]; }),
                    _: 3
                }, 8, ["appid", "extinfo"])
            ]));
        };
    }
});
